import * as React from "react";
import DateUtils from "../../../../utils/DateUtils";
import "./timePickerList.scss";
import {isNullOrUndefined} from "util";
import {Moment} from "moment";
import moment = require("moment");

interface IProps {
	/**
	 * initial moment date from reminder.
	 */
	initialDate: moment.Moment;
	/**
	 * On time change handler.
	 */
	onTimeSelect: (moment: moment.Moment) => void;
	/**
	 * Time picker interval in minutes.
	 */
	interval?: number;
	/**
	 * On outside click callback.
	 */
	onOutsideClick?: () => void;
	/**
	 * Start time in 'HH:mm' format.
	 */
	startTime?: string;
	/**
	 * End time in 'HH:mm' format.
	 */
	endTime?: string;
	/**
	 * Disabled date times
	 */
	disabledDateTimes?: moment.Moment[]
}

export default class TimePickerList extends React.Component<IProps, {}> {

	public static defaultProps: Partial<IProps> = {
		interval: 30,
		startTime: "00:00",
		endTime: "23:59"
	};

	timePicker: HTMLDivElement;
	timePickerList: HTMLDivElement;

	constructor(props: IProps) {
		super(props);
		this.state = {
			timePickerVisible: false
		};
		this.renderTimeItems = this.renderTimeItems.bind(this);
		this.handleElementClick = this.handleElementClick.bind(this);
		this.generateTime = this.generateTime.bind(this);
		this.onTimePickerShow = this.onTimePickerShow.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	}

	componentDidMount() {
		document.addEventListener("mousedown", this.handleOutsideClick);
		this.onTimePickerShow();
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleOutsideClick);
	}

	render() {

		return (
			<div className={"m-time-picker"} ref={(tp) => this.timePicker = tp}>
				<div className={"m-time-picker_list"} ref={(tpl) => this.timePickerList = tpl}>
					<ul>
						{this.renderTimeItems()}
					</ul>
				</div>
			</div>
		);
	}

	/**
	 * Render time items in time selector dropdown.
	 * @return {any[]}
	 */
	renderTimeItems() {
		const now = moment();
		return this.generateTime().map((dateTime, index) => {

			const isPast = dateTime.isBefore(now, "minute");
			const isDisabled = this.props.disabledDateTimes &&
				this.props.disabledDateTimes.map(ad => dateTime.isSame(ad)).some(disabled => disabled);

			const className = `${isPast || isDisabled ? "is-disabled" : "is-enabled"}`;

			const onClick = isPast || isDisabled ? () => {} : this.handleElementClick;
			return (
				<li key={index} onClick={() => {onClick(dateTime); }}
					className={className}>
					{dateTime.format(DateUtils.REMINDER_TIME_FORMAT)}
				</li>
			);
		});
	}

	/**
	 * On time picker show scroll list to first enable element.
	 */
	onTimePickerShow() {
		const el: HTMLLIElement = document.querySelector(".is-enabled");
		if (!isNullOrUndefined(el) && !isNullOrUndefined(this.timePickerList)) {
			this.timePickerList.scrollTop = el.offsetTop;
		}
	}

	/**
	 * Generate list of moments based on reminder date.
	 * @return {moment.Moment[]}
	 */
	generateTime() {
		const startTime = moment(this.props.startTime, "HH:mm").diff(moment().startOf("day"), "minutes");
		const endTime = moment(this.props.endTime, "HH:mm").diff(moment().startOf("day"), "minutes");
		const time = [];
		for (let t = startTime; t <= endTime; t += this.props.interval) {
			let date = this.props.initialDate ? this.props.initialDate : moment();
			time.push(moment(date).startOf("day").add(t, "m"));
		}
		return time;
	}

	/**
	 * Handle time item click.
	 */
	handleElementClick(time: moment.Moment) {
		this.props.onTimeSelect(time);
	}

	/**
	 * Handle outside click.
	 */
	handleOutsideClick(evt: Event) {
		if (this.timePicker && !this.timePicker.contains(evt.target as HTMLElement) &&
			!isNullOrUndefined(this.props.onOutsideClick)) {
			this.props.onOutsideClick();
		}
	}
}
